import type { FC } from 'react';
import { useDragLayer } from 'react-dnd-cjs';
import { DraggableType } from '@wix/da-shared-react/pkg/types/dnd';
import { useNormalizedDeviationStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import { STUDIO_DEVIATIONS_STREAM } from '../../../constants';
import { useDraftsSelect } from '../../hooks/useDraftsSelect';
import DeviationThumb from '../StudioDeviationList/_partials/DeviationThumb';

import s from './StudioTableDragLayer.scss';

const THUMB_SIZE = 60;
const THUMB_STACK_ROTATION = 45;

const StudioTableDragLayer: FC<{}> = () => {
  const { item, itemType, isDragging, clientOffset } = useDragLayer(
    monitor => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      clientOffset: monitor.getClientOffset(),
      isDragging: monitor.isDragging(),
    })
  );

  const { streamId, streamConfig, streamThrottle } = STUDIO_DEVIATIONS_STREAM;
  const { items: deviations } = useNormalizedDeviationStream(
    streamId,
    streamThrottle,
    streamConfig
  );
  const { selected } = useDraftsSelect(deviations);
  const selectedDeviations = deviations.filter(
    (deviation, idx) =>
      selected.includes(idx) || item?.id === deviation.deviationId
  );
  const numSelected = selectedDeviations.length;

  if (!(numSelected && isDragging)) {
    return null;
  }

  return (
    <div className={s['root']}>
      {itemType === DraggableType.STUDIO_TABLE_ROW && clientOffset && (
        <div
          className={s['stack']}
          style={{
            transform: `translate(
            ${clientOffset.x - THUMB_SIZE / 2}px,
            ${clientOffset.y - THUMB_SIZE}px
          )`,
          }}
        >
          {selectedDeviations.map((deviation, idx) => (
            <div
              className={s['stack-item']}
              key={deviation.deviationId}
              style={{
                transform: `rotate(
                  ${-idx * (THUMB_STACK_ROTATION / numSelected)}deg
                )`,
                zIndex: numSelected - idx,
              }}
            >
              <DeviationThumb deviation={deviation} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
StudioTableDragLayer.displayName = 'StudioTableDragLayer';

export default StudioTableDragLayer;
